#import "./competitor-for-lead-fragment.graphql"

fragment CompetitorsLeadFragment on Lead {
    id
    competitors {
        edges {
            node {
                ...CompetitorForLeadFragment
            }
            relationshipNote
        }
        totalCount
    }
}
